var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AddGoal',{attrs:{"showAddGoal":_vm.showAddGoal},on:{"close":function($event){_vm.showAddGoal = false}}}),_c('div',{staticClass:"bg-white m-3 rounded-md"},[_c('div',{staticClass:"border-b-0.5 lg:gap-0 gap-5 items-center p-3 w-full"},[_c('employee-list')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }